import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCZw-BpvtfWhjwASdHbvtKQ_kPbsBhqN5E",
  authDomain: "complimate-466404.firebaseapp.com",
  projectId: "complimate-466404",
  storageBucket: "complimate-466404.firebasestorage.app",
  messagingSenderId: "990795911606",
  appId: "1:990795911606:web:076a7f5aec03388ae23117"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging and get a reference to the service
const messaging = getMessaging(app);

export { app, messaging, firebaseConfig };
